const technologies = {
    python: "/imgs/logos/python.png",
    javascript: "/imgs/logos/javascript.png",
    cpp: "/imgs/logos/cpp.png",
    html: "/imgs/logos/html.png",
    css: "/imgs/logos/css.png",
    react: "/imgs/logos/react.png",
    msoffice: "/imgs/logos/msoffice.png",
    pythonflask: "/imgs/logos/pythonflask.png",
    appscript: "/imgs/logos/appscript.png",
    laptop: "/imgs/logos/laptop.png",
    discord: "/imgs/logos/discord.png",
    gemini: "/imgs/logos/gemini.png",
    firebase: "/imgs/logos/firebase.png",
    postgres: "/imgs/logos/postgres.png",
    
  };
  
  export default technologies;
  